/*
 * Lista desideri e tasti rapidi sulle schede prodotto.
 *
 * Tutto in JavaScript e in localStorage, senza app e senza account: il negozio ha sei markup di
 * scheda diversi (Dawn piu' cinque sezioni artop-*), e mettere un cuore dentro ognuno avrebbe
 * voluto dire modificare sei file e ricordarsene al settimo. Qui si cerca il link al prodotto,
 * che c'e' in tutte, e si aggancia da fuori.
 *
 * Il salvataggio e' nel browser di chi guarda: sopravvive alla ricarica, non e' condiviso fra
 * dispositivi. Per una lista desideri e' il compromesso giusto - niente da installare, niente
 * canone - e il giorno che servisse condivisa si sostituisce solo la parte `Lista`.
 */
(function () {
  'use strict';

  var CHIAVE = 'artop:lista-desideri';
  var PAGINA = '/pages/lista-desideri';

  /* ---------- il magazzino ---------- */
  var Lista = {
    leggi: function () {
      try { return JSON.parse(localStorage.getItem(CHIAVE)) || []; } catch (e) { return []; }
    },
    scrivi: function (v) {
      try { localStorage.setItem(CHIAVE, JSON.stringify(v)); } catch (e) { /* quota piena o modalita' privata */ }
      aggiornaConteggio();
      document.dispatchEvent(new CustomEvent('artop:lista-cambiata'));
    },
    ha: function (h) { return this.leggi().indexOf(h) !== -1; },
    inverti: function (h) {
      var v = this.leggi(), i = v.indexOf(h);
      if (i === -1) v.unshift(h); else v.splice(i, 1);
      this.scrivi(v);
      return i === -1;
    },
    togli: function (h) {
      var v = this.leggi(), i = v.indexOf(h);
      if (i !== -1) { v.splice(i, 1); this.scrivi(v); }
    },
  };

  /** L'handle sta nell'URL del prodotto: /products/<handle>[?...] */
  function handleDa(href) {
    if (!href) return null;
    var m = String(href).match(/\/products\/([^/?#]+)/);
    return m ? m[1] : null;
  }

  var CUORE = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">'
    + '<path d="M12 20.7 4.6 13.3a4.6 4.6 0 0 1 0-6.5 4.6 4.6 0 0 1 6.5 0l.9.9.9-.9a4.6 4.6 0 0 1 6.5 0 '
    + '4.6 4.6 0 0 1 0 6.5Z"/></svg>';
  var CARRELLO = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">'
    + '<path d="M6 6h15l-1.6 8.4a2 2 0 0 1-2 1.6H9.2a2 2 0 0 1-2-1.6L5.2 4H2" fill="none" stroke="currentColor" '
    + 'stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>'
    + '<circle cx="10" cy="20" r="1.4"/><circle cx="18" cy="20" r="1.4"/></svg>';

  /* ---------- i tasti sulle schede ---------- */

  /**
   * La scheda: si risale dal link al primo antenato che somiglia a una scheda e contiene
   * un'immagine.
   *
   * SI PARTE DAL LINK STESSO, non dal suo genitore. Nel carosello della home la scheda E' il
   * link (`<a class="artop-cc__card">`): partendo dal genitore la si saltava e il primo antenato
   * che combaciava era la pista del carosello, larga quanto lo schermo. Da li' la pillola nera
   * "AGGIUNGI" che attraversava due schede coprendo titolo e prezzo, e un solo gruppo di tasti
   * per pista invece di uno per scheda.
   *
   * Il controllo sull'immagine serve negli elenchi di ricerca, dove il primo antenato che
   * combacia puo' essere ".artop-search__card-title", che e' solo testo.
   */
  function schedaDi(a) {
    var sel = '.card-wrapper, .card, .artop-cc__card, .artop-grid__card, .artop-others__card,'
      + ' .grid__item, .product-card, [class*="__card"]';
    for (var n = a, giri = 0; n && giri < 8; n = n.parentElement, giri++) {
      if (n.matches(sel) && n.querySelector('img')) return n;
    }
    var p = a.parentElement;
    return p && p.querySelector('img') ? p : null;
  }

  /**
   * I tasti vanno appesi ALLA SCHEDA, per ultimi, e non dentro il riquadro della foto.
   *
   * Dentro il riquadro sembrava la scelta giusta - li' non c'e' testo da coprire - ma su Dawn
   * quel riquadro (.card__inner) ha un `transform`, e un transform crea un contesto di
   * impilamento: qualunque z-index messo li' dentro resta confinato. Il velo che rende
   * cliccabile tutta la scheda (.full-unstyled-link::after, z-index 1) vive invece in
   * .card__content, che e' un fratello SUCCESSIVO, quindi si dipinge sopra a prescindere.
   * Misurato: elementFromPoint sul centro del cuore restituiva il link, non il tasto.
   * Da li' il sintomo, cioe' il clic che apriva la scheda prodotto invece di aggiungere.
   *
   * Appesi in fondo alla scheda i tasti stanno nello stesso contesto del velo e lo superano.
   * In cambio devono stare tutti e due in alto - la foto e' sempre in cima alla scheda, mentre
   * il suo fondo non si sa dove sia senza fare i conti sull'altezza dell'immagine.
   */
  function contenitoreTasti(scheda) {
    var g = scheda.querySelector(':scope > .atw-tasti');
    if (g) return g;
    if (getComputedStyle(scheda).position === 'static') scheda.style.position = 'relative';
    g = document.createElement('div');
    g.className = 'atw-tasti';
    scheda.appendChild(g);
    return g;
  }

  function attrezzaSchede(radice) {
    var link = (radice || document).querySelectorAll('a[href*="/products/"]');
    for (var i = 0; i < link.length; i++) {
      var a = link[i];
      var h = handleDa(a.getAttribute('href'));
      if (!h) continue;
      var s = schedaDi(a);
      if (!s) continue;
      // dentro la pagina della lista i tasti li disegna disegnaPagina(), non qui;
      // nel menu a tendina e nei suggerimenti di ricerca non servono: li' si sta navigando,
      // non si sta guardando un prodotto
      if (s.closest('.artop-wishlist, .artop-drawer, .artop-search, .menu-drawer, predictive-search')) continue;
      if (s.querySelector('.atw-desideri')) continue;
      var box = contenitoreTasti(s);

      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'atw-desideri' + (Lista.ha(h) ? ' is-on' : '');
      b.setAttribute('data-handle', h);
      b.setAttribute('aria-pressed', Lista.ha(h) ? 'true' : 'false');
      b.setAttribute('aria-label', 'Aggiungi alla lista desideri');
      b.title = 'Lista desideri';
      b.innerHTML = CUORE;
      box.appendChild(b);

      var c = document.createElement('button');
      c.type = 'button';
      c.className = 'atw-rapido';
      c.setAttribute('data-handle', h);
      c.setAttribute('aria-label', 'Aggiungi al carrello');
      c.title = 'Aggiungi al carrello';
      // il testo resta per chi legge con uno screen reader, ma non si vede: sulla scheda e'
      // un'icona, e la scritta a tutta larghezza copriva il prodotto
      c.innerHTML = CARRELLO + '<span class="atw-solo-voce">Aggiungi</span>';
      box.appendChild(c);
    }
  }

  /* ---------- il carrello rapido ---------- */

  /**
   * La variante non si sa dalla scheda, quindi si chiede al negozio al momento del clic: una
   * richiesta sola, e solo per chi preme davvero. Se il prodotto ha piu' varianti disponibili si
   * manda alla scheda a scegliere, invece di decidere al posto suo.
   */
  async function aggiungiAlCarrello(handle, tasto) {
    tasto.classList.add('is-attesa');
    try {
      var p = await (await fetch('/products/' + handle + '.js')).json();
      var disp = (p.variants || []).filter(function (v) { return v.available; });
      if (!disp.length) { avviso(tasto, 'Esaurito', false); return; }
      if (disp.length > 1) { window.location.href = '/products/' + handle; return; }

      /*
       * Le SEZIONI vanno chieste nella stessa richiesta dell'aggiunta.
       *
       * Prima si chiamava /cart/add.js liscio e poi d.open(): il prodotto entrava davvero nel
       * carrello - misurato, /cart.js passava da 0 a 1 - ma il cassetto era ancora quello
       * disegnato dal server al caricamento della pagina, cioe' vuoto. Si apriva su "Il tuo
       * carrello e' vuoto" con dentro un articolo. Poi al primo cambio pagina l'articolo
       * compariva, e sembrava che il negozio aggiungesse il prodotto sbagliato, quello di prima.
       *
       * Shopify sa ridisegnare le sezioni nella risposta stessa: si chiede `sections`, e si passa
       * il risultato a renderContents() di Dawn, che aggiorna cassetto e pallino e lo apre da se'.
       */
      var d = document.querySelector('cart-drawer');
      var sezioni = d && typeof d.getSectionsToRender === 'function'
        ? d.getSectionsToRender().map(function (s) { return s.id; })
        : ['cart-icon-bubble'];
      var r = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: [{ id: disp[0].id, quantity: 1 }],
          sections: sezioni,
          sections_url: window.location.pathname,
        }),
      });
      if (!r.ok) throw new Error('carrello');
      var esito = await r.json();
      avviso(tasto, 'Aggiunto', true);
      if (d && typeof d.renderContents === 'function' && esito.sections) {
        d.renderContents(esito);
      } else {
        // niente cassetto (o tema diverso): almeno il pallino deve dire il vero
        var b = document.getElementById('cart-icon-bubble');
        var htm = esito.sections && esito.sections['cart-icon-bubble'];
        if (b && htm) {
          var nuovo = new DOMParser().parseFromString(htm, 'text/html').querySelector('.shopify-section');
          if (nuovo) b.innerHTML = nuovo.innerHTML;
        }
      }
    } catch (e) {
      avviso(tasto, 'Riprova', false);
    } finally {
      tasto.classList.remove('is-attesa');
    }
  }

  /**
   * L'esito del clic. Sulla scheda il tasto e' un'icona e la scritta non si vede, quindi il
   * riscontro e' un colore: verde se e' andata, rosso se no. Il testo si aggiorna lo stesso,
   * perche' e' quello che legge uno screen reader; nella pagina della lista, dove il tasto e'
   * testuale, si vede anche.
   */
  function avviso(tasto, testo, andata) {
    tasto.classList.remove('e-fatto', 'e-no');
    // forza il ricalcolo dell'animazione se si preme due volte di fila
    void tasto.offsetWidth;
    tasto.classList.add(andata ? 'e-fatto' : 'e-no');
    var s = tasto.querySelector('span');
    var prima = s ? s.textContent : null;
    if (s) s.textContent = testo;
    setTimeout(function () {
      tasto.classList.remove('e-fatto', 'e-no');
      if (s) s.textContent = prima;
    }, 1600);
  }

  /* ---------- il contatore in testata ---------- */
  function aggiornaConteggio() {
    var n = Lista.leggi().length;
    var voci = document.querySelectorAll('.atw-testata-desideri');
    for (var i = 0; i < voci.length; i++) {
      var b = voci[i].querySelector('.atw-testata-desideri__n');
      if (b) { b.textContent = n; b.hidden = n === 0; }
    }
  }

  /** Una voce accanto al carrello, senza toccare il liquid della testata. */
  /**
   * Dove appendere il cuore in testata: accanto all'icona del carrello.
   *
   * I selettori si provano UNO ALLA VOLTA, in ordine di preferenza. Messi tutti insieme in una
   * querySelector con le virgole, il browser non restituisce il primo SELETTORE che combacia ma
   * il primo ELEMENTO nell'ordine del documento: bastava un qualunque link verso /cart piu' in
   * alto nella pagina - una scorciatoia, un link dentro il cassetto del carrello - e il cuore
   * finiva la' dentro, dove non si vede.
   */
  function iconaCarrello() {
    var perOrdine = [
      function () { return document.getElementById('cart-icon-bubble'); },
      function () { return document.querySelector('header a[href="/cart"], .header a[href="/cart"]'); },
      function () { return document.querySelector('a[href="/cart"]'); },
      function () { return document.querySelector('a[href*="/cart"]'); },
    ];
    for (var i = 0; i < perOrdine.length; i++) {
      var n = perOrdine[i]();
      // un elemento senza offsetParent e' nascosto: appenderci il cuore lo nasconderebbe con lui
      if (n && (n.offsetParent !== null || n.getClientRects().length)) return n;
    }
    return null;
  }

  function metsiInTestata() {
    if (document.querySelector('.atw-testata-desideri')) return;
    var carrello = iconaCarrello();
    if (!carrello) return;
    var a = document.createElement('a');
    a.href = PAGINA;
    a.className = 'atw-testata-desideri';
    a.setAttribute('aria-label', 'Lista desideri');
    a.title = 'Lista desideri';
    a.innerHTML = CUORE + '<span class="atw-testata-desideri__n" hidden>0</span>';
    var padre = carrello.closest('a') || carrello;
    padre.parentNode.insertBefore(a, padre);
    aggiornaConteggio();
  }

  /* ---------- la pagina della lista ---------- */
  async function disegnaPagina() {
    var box = document.querySelector('[data-atw-lista]');
    if (!box) return;
    var handle = Lista.leggi();
    if (!handle.length) {
      box.innerHTML = '<p class="atw-lista__vuota">La tua lista e\' vuota. Il cuore sulle schede '
        + 'serve a tenere da parte quello che ti piace.</p>'
        + '<a class="atw-lista__cta" href="/collections/arredo-parete">Guarda l\'arredo parete</a>';
      return;
    }
    box.innerHTML = '<p class="atw-lista__attesa">Carico&hellip;</p>';
    var schede = await Promise.all(handle.map(async function (h) {
      try {
        var p = await (await fetch('/products/' + h + '.js')).json();
        return { h: h, p: p };
      } catch (e) { return null; }
    }));
    var vive = schede.filter(Boolean);
    // un prodotto sparito dal catalogo non deve restare nella lista a dare errore
    if (vive.length !== handle.length) Lista.scrivi(vive.map(function (x) { return x.h; }));
    if (!vive.length) return disegnaPagina();

    box.innerHTML = '<div class="atw-lista__griglia">' + vive.map(function (x) {
      var p = x.p;
      var img = p.featured_image ? p.featured_image.replace(/(\.[a-z]+)(\?|$)/i, '_600x$1$2') : '';
      var prezzo = (p.price / 100).toFixed(2).replace('.', ',') + ' &euro;';
      return '<article class="atw-lista__card">'
        + '<button type="button" class="atw-lista__x" data-togli="' + x.h + '" aria-label="Togli dalla lista">&times;</button>'
        + '<a href="' + p.url + '">'
        + (img ? '<img src="' + img + '" alt="" loading="lazy">' : '<span class="atw-lista__nofoto"></span>')
        + '<h3>' + p.title + '</h3></a>'
        + '<p class="atw-lista__prezzo">' + prezzo + '</p>'
        + '<button type="button" class="atw-rapido atw-rapido--largo" data-handle="' + x.h + '">'
        + CARRELLO + '<span>Aggiungi</span></button>'
        + '</article>';
    }).join('') + '</div>';
  }

  /* ---------- avvio ---------- */
  /*
   * IN FASE DI CATTURA, non di risalita.
   *
   * I tasti stanno DENTRO il link della scheda. Un ascoltatore sul document in risalita e'
   * l'ultimo a ricevere il clic: basta che un gestore del tema in mezzo chiami
   * stopPropagation() - i caroselli lo fanno spesso, per distinguere il trascinamento dal
   * clic - e il mio non parte piu'. Il preventDefault non arriva mai e il browser segue il
   * link: si preme il cuore e si finisce sulla scheda prodotto.
   *
   * In cattura il document e' il PRIMO a vedere l'evento, prima di chiunque altro, quindi
   * preventDefault e stopPropagation valgono comunque.
   */
  document.addEventListener('click', function (e) {
    var cuore = e.target.closest('.atw-desideri');
    if (cuore) {
      e.preventDefault(); e.stopPropagation();
      var acceso = Lista.inverti(cuore.getAttribute('data-handle'));
      cuore.classList.toggle('is-on', acceso);
      cuore.setAttribute('aria-pressed', acceso ? 'true' : 'false');
      // gli altri cuori dello stesso prodotto in pagina devono seguire
      var gemelli = document.querySelectorAll('.atw-desideri[data-handle="' + cuore.getAttribute('data-handle') + '"]');
      for (var i = 0; i < gemelli.length; i++) gemelli[i].classList.toggle('is-on', acceso);
      return;
    }
    var rapido = e.target.closest('.atw-rapido');
    if (rapido) {
      e.preventDefault(); e.stopPropagation();
      aggiungiAlCarrello(rapido.getAttribute('data-handle'), rapido);
      return;
    }
    var x = e.target.closest('[data-togli]');
    if (x) { e.preventDefault(); Lista.togli(x.getAttribute('data-togli')); disegnaPagina(); }
  }, true);

  function avvia() {
    attrezzaSchede(document);
    metsiInTestata();
    disegnaPagina();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', avvia);
  else avvia();

  // le sezioni si ridisegnano da sole (filtri, caroselli, paginazione): si riattrezza a valle
  var attesa = null;
  new MutationObserver(function () {
    clearTimeout(attesa);
    attesa = setTimeout(function () {
      attrezzaSchede(document);
      // anche il cuore in testata: se la testata si disegna dopo l'avvio, un tentativo solo non
      // basta. metsiInTestata non raddoppia, esce subito se il cuore c'e' gia'.
      metsiInTestata();
    }, 150);
  }).observe(document.documentElement, { childList: true, subtree: true });

  document.addEventListener('artop:lista-cambiata', disegnaPagina);
  window.ArtopListaDesideri = Lista;
}());
